import styled from 'styled-components'

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  //height: 600px;
  background: ${ (props) => props.theme.colors.weiss };
  padding: 10px;
  z-index: ${ (props) => props.theme.zIndices.modal };
  overflow-y: auto;
  overflow-x: hidden;
`

export const CloseModal = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
  background: transparent;
  padding: 15px;

  &:focus {
    outline: 0;

    span[class*='icon-'] {
      color: ${ (props) => props.theme.colors['icon-grau1'] };
    }
  }

  span[class*='icon-'] {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 24px;
    height: 24px;
    font-size: 18px;
    line-height: 1;
    color: ${ (props) => props.theme.colors['icon-grau2'] };
  }
`
